import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface ChatWithSupportBottomSheetProps {
  modalState: UseModalState;
  shiftId: string;
}

export function ChatWithSupportBottomSheet(props: ChatWithSupportBottomSheetProps) {
  const { modalState, shiftId } = props;

  const handleStartChat = () => {
    logEvent(APP_V2_USER_EVENTS.SHIFT_HISTORY_CHAT_WITH_SUPPORT_TAPPED, { shiftId });
    void openZendeskMessaging();
    modalState.closeModal();
  };

  const handleOk = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet modalState={modalState}>
      <BottomSheetIllustrationContent
        illustrationType="chat"
        title="Chat with support"
        description="If you were not paid accurately for this shift, please reach out to support."
      />
      <DialogFooter orientation="vertical" sx={{ paddingTop: 11 }}>
        <Button fullWidth variant="contained" size="large" onClick={handleOk}>
          Ok
        </Button>
        <Button fullWidth variant="outlined" size="large" onClick={handleStartChat}>
          Start chat
        </Button>
      </DialogFooter>
    </BottomSheet>
  );
}
